import { apiClient } from "./api";
import { Tenant, Chatbot } from "../types";

interface ApiOk<T> {
  ok: true;
  data: T;
}

export const provisioningService = {
  createTenant: (body: {
    name: string;
    wa_phone_number_id: string;
    wa_verify_token: string;
    wa_access_token_value: string;
    openai_api_key_value: string;
  }) =>
    apiClient.post<ApiOk<{ tenant: Tenant }>>("/v1/provisioning/tenants", body),

  createChatbot: (body: {
    tenant_id: string;
    system_prompt: string;
    model: Chatbot["model"];
    temperature: number;
    max_tokens: number;
    max_history: number;
    flow_id?: string | null;
  }) =>
    apiClient.post<ApiOk<{ chatbot: Chatbot }>>(
      "/v1/provisioning/chatbots",
      body
    ),

  deactivateTenant: (tenantId: string) =>
    apiClient.delete(`/v1/provisioning/tenants/${tenantId}`),

  rotateTokens: (
    tenantId: string,
    body: {
      wa_access_token_value?: string;
      openai_api_key_value?: string;
    }
  ) =>
    apiClient.patch(
      `/v1/provisioning/tenants/${tenantId}/tokens`,
      body
    ),
};
